<template>
  <div>
    <b-row class="mb-2">
      <b-col
        v-if="loadingAll"
        cols="12"
      >
        <loading />
      </b-col>
      <b-col
        v-else
        cols="12"
      >
        <csi-tabs />
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col cols="12">
        <csi-filter :get-report-data="getData" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading />
      </b-col>
      <template v-else-if="reportData.monthly.length">
        <b-col cols="12">
          <csi-mixed-charts
            v-if="reportData.chartData.series.length"
            title-text="CSI"
            :series-data="reportData.chartData.series"
            :categories-data="['OCAK', 'ŞUBAT', 'MART', 'NİSAN', 'MAYIS', 'HAZİRAN', 'TEMMUZ',
                               'AĞUSTOS', 'EYLÜL', 'EKİM', 'KASIM', 'ARALIK']"
          />
        </b-col>
        <b-col cols="12">
          <b-card no-body>
            <b-table
              striped
              hover
              responsive
              :fields="fields"
              :items="reportData.monthly"
            >
              <template #cell(brand)="data">
                {{ data.item.brand }}
                <div class="font-small-2 text-warning">
                  {{ data.item.location }}
                </div>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BTable,
} from 'bootstrap-vue'
import CsiFilter from '@/views/Crm/FilterCards/CsiFilter.vue'
import Loading from '@/layouts/components/Loading.vue'
import CsiMixedCharts from '@/layouts/components/ReportCharts/CsiMixedCharts.vue'
import CsiTabs from '@/views/Crm/Csi/CsiTabs.vue'

export default {
  name: 'Index',
  components: {
    CsiFilter,
    Loading,
    CsiMixedCharts,
    CsiTabs,
    BRow,
    BCol,
    BCard,
    BTable,
  },
  data() {
    return {
      fields: [
        {
          key: 'brand',
          label: 'Marka / Lokasyon',
          sortable: false,
        },
        {
          key: 'month',
          label: 'Ay',
          sortable: false,
          thClass: 'width-200',
          tdClass: '',
        },
        {
          key: 'score',
          label: 'Skor',
          sortable: true,
          thClass: 'text-center width-200',
          tdClass: 'text-center',
        },
        {
          key: 'goals',
          label: 'Hedef',
          sortable: true,
          thClass: 'text-center width-200',
          tdClass: 'text-center',
        },
        {
          key: 'ranking',
          label: 'Türkiye Sıralaması',
          sortable: true,
          thClass: 'text-center width-200',
          tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    loading() {
      return this.$store.getters['crmCsiReports/loading']
    },
    loadingAll() {
      return this.$store.getters['crmCsiReports/loadingAll']
    },
    reportData() {
      return this.$store.getters['crmCsiReports/reportData']
    },
    filterParams() {
      return this.$store.getters['crmCsiReports/filterParams']
    },
  },
  created() {
    this.getFilterItems()
    this.getDataAll()
  },
  methods: {
    getFilterItems() {
      this.$store.dispatch('crmCsiReports/getFilterItems')
    },
    getDataAll() {
      this.$store.dispatch('crmCsiReports/getDataAll')
    },
    getData() {
      this.$store.dispatch('crmCsiReports/getData', this.filterParams)
    },
  },
}
</script>
